import { JobGroup } from "src/models/job";
import { createEntityModel } from "src/store/models/entity/_shared";

export const JobGroupEntityModel = createEntityModel<JobGroup>();
